export default __webpack_public_path__ + "static/media/before@2x.71c86030.jpg";